export default __webpack_public_path__ + "static/media/services-icon3.eda949af.png";